"use strict";
exports.__esModule = true;
exports.RelationKind = exports.InternalEntityProperty = void 0;
var InternalEntityProperty;
(function (InternalEntityProperty) {
    InternalEntityProperty["type"] = "__type";
    InternalEntityProperty["nodeId"] = "__nodeId";
    InternalEntityProperty["primaryKey"] = "__primaryKey";
})(InternalEntityProperty = exports.InternalEntityProperty || (exports.InternalEntityProperty = {}));
var RelationKind;
(function (RelationKind) {
    RelationKind["OneOf"] = "oneOf";
    RelationKind["ManyOf"] = "manyOf";
})(RelationKind = exports.RelationKind || (exports.RelationKind = {}));
